import { Routes } from '@angular/router';
import {
	AuthGuard,
	redirectLoggedInTo,
	redirectUnauthorizedTo,
} from '@angular/fire/auth-guard';
import { onboardingGuardGuard } from './guards/onboardingGuard.guard';

const redirectUnauthorizedToAuth = () => redirectUnauthorizedTo(['auth']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);

export const routes: Routes = [
	{
		path: 'auth',
		title: 'Login',
		loadComponent: () => import('./modules/auth/auth.component'),
		canActivate: [AuthGuard],
		data: { authGuardPipe: redirectLoggedInToHome },
	},
	{
		path: 'home',
		title: 'The Coffee Bara',
		loadComponent: () => import('./modules/home/home.component'),
		canActivate: [AuthGuard, onboardingGuardGuard],
		data: { authGuardPipe: redirectUnauthorizedToAuth },
	},
	{
		path: 'onboarding',
		title: 'Onboarding',
		loadComponent: () =>
			import('./modules/onboarding/onboarding.component'),
		canActivate: [AuthGuard, onboardingGuardGuard],
		data: { authGuardPipe: redirectUnauthorizedToAuth },
	},
	{
		path: 'admin',
		title: 'Admin',
		loadComponent: () => import('./modules/admin/admin.component'),
		canActivate: [AuthGuard],
		data: { authGuardPipe: redirectUnauthorizedToAuth },
	},
	// {
	// 	path: 'capy-ia',
	// 	title: 'Capy IA',
	// 	loadComponent: () => import('./modules/capy-ia/capy-ia.component'),
	// 	canActivate: [AuthGuard],
	// 	data: { authGuardPipe: redirectUnauthorizedToAuth },
	// },
	{
		path: '**',
		redirectTo: 'auth',
		pathMatch: 'full',
	},
];
